function _(t,i,n){t(62),t(61).styles.append(".bk-root .bk-tile-attribution a {\n  color: black;\n}\n"),n.bk_tile_attribution="bk-tile-attribution"}
//# sourceMappingURL=tiles.min.js.map